import React, { useEffect, useState } from "react";
import { FIFAEmbeddablePlayer } from "fifa-embeddable-player";
import { FIFA_LOGO_URL } from "../../constants";
import { ColorRing } from "react-loader-spinner";

import Style from "./VideoEmbed.module.scss";

const VideoEmbed = ({ partnerName }: { partnerName: string }): JSX.Element => {
  const playerRef = React.createRef<HTMLDivElement>();
  const [isLoadingPlaylistData, setIsLoadingPlaylistData] = useState<boolean>(true);

  const stringToBooleanTernary = (str : string) => {
    // Ternary operator: condition ? true-value : false-value
    return str.toLowerCase() === 'true' ? true : false;
  }

  useEffect(() => {
    const config = {
      name: "",
      environment: "",
      license: process.env.REACT_APP_THEOPLAYER_LICENSE_KEY ?? "",
      playlistCode: process.env.REACT_APP_PLAYLIST_CODE ?? "",
      playlistSpaceId:
        process.env[`REACT_APP_${partnerName.toUpperCase()}_PLAYLIST_SPACE_ID`] 
        ?? process.env["REACT_APP_DEFAULT_SPACE_ID"] 
        ?? "",
      playlistEnvironmentId:
        process.env[`REACT_APP_${partnerName.toUpperCase()}_PLAYLIST_ENV_ID`] 
        ?? process.env["REACT_APP_DEFAULT_ENV_ID"]
        ?? "",
      playlistEntryId:
        process.env[
          `REACT_APP_${partnerName.toUpperCase()}_PLAYLIST_ENTRY_ID`
        ] ?? "",
      marketingUserId: "",
      playlistVisible: stringToBooleanTernary(process.env[
            `REACT_APP_${partnerName.toUpperCase()}_PLAYLIST_VISIBLE`
        ] ?? "false"),
      playlistUrl: "https://origin1904-embedded-video-player-p.cxm.fifa.com/api/GetPartnerVideoPlaylist"
    };
    const embedPlayer = new FIFAEmbeddablePlayer(
      playerRef?.current as HTMLElement,
      config
    );

    const callbackHandler = (mutationList: MutationRecord[]) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          setIsLoadingPlaylistData(false);
        }
      }
    };

    const videoTitleElement = document.getElementById("vid-title-attribute");
    if (videoTitleElement) {
      const observer = new MutationObserver(callbackHandler);
      observer.observe(videoTitleElement, {
        childList: true,
      });
    }

    if (embedPlayer) {
      // the player is ready now 
    }
    const fifaLogo = document.createElement("img");
    fifaLogo.src = FIFA_LOGO_URL;
    fifaLogo.alt = "FIFA Logo";
    fifaLogo.className = "fifa-logo";
    const mainContentRoot = document.getElementById("main-content-row");
    mainContentRoot?.insertBefore(fifaLogo, mainContentRoot.childNodes[0]);
  }, []);

  return (
    <div className="container">
      <div
        ref={playerRef}
        className={isLoadingPlaylistData ? Style.hidePlayList : ""}
      />
      <ColorRing
        wrapperClass={Style.loadingSpinner}
        visible={isLoadingPlaylistData}
        colors={["white", "white", "white", "white", "white"]}
      />
    </div>
  );
};

export default VideoEmbed;
